
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink, Router, ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ShamLockPasswordBulkIcon } from 'sham-components/icons';
import { TranslateModule } from '@ngx-translate/core';
import { AuthApi } from '@/app/services/auth-api';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [
    RouterLink,
    CommonModule,
    FormsModule,
    ShamLockPasswordBulkIcon,
    ShamLockPasswordBulkIcon,
    TranslateModule
  ],
  templateUrl: './reset-password.html',
  styleUrl: './reset-password.css',
})
export class ResetPasswordPage {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private authApi = inject(AuthApi);

  password = '';
  confirmPassword = '';
  email = '';
  resetToken = '';

  isLoading = false;
  errorMessage = '';

ngOnInit() {
  const authData = this.authApi.getAuthFlowData();

  this.email = authData.email || '';
  this.resetToken = authData.resetToken || '';

  if (!this.email || !this.resetToken) {
    this.router.navigate(['/auth/forgot-password']);
    return;
  }
}

  onReset() {
    this.errorMessage = '';

    if (this.password !== this.confirmPassword) {
      this.errorMessage = 'كلمة المرور غير متطابقة';
      return;
    }

    this.isLoading = true;

    this.authApi.resetPassword({
      email: this.email,
      newPassword: this.password,
      confirmPassword: this.confirmPassword,
      resetToken: this.resetToken
    }).subscribe({
      next: () => {
        this.isLoading = false;
          this.authApi.clearAuthFlowData();

        this.router.navigate(['/auth/reset-success']);
      },
      error: (err) => {
        this.isLoading = false;
        this.errorMessage = err.error?.message || 'حدث خطأ أثناء تغيير كلمة المرور';
      }
    });
  }
}
